import { useCallback } from 'react'
import shortid from 'shortid'

import { useProject } from 'hooks'

export const useProducts = () => {
  const { project, updateProjectPart, canEdit } = useProject()
  const products = project?.products || []

  const updateProducts = (updatedProducts) => {
    const productMap = [...products, ...updatedProducts].reduce((acc, it) => ({ ...acc, [it.id]: it }), {})
    updateProjectPart('products', Object.values(productMap))
  }

  const saveProduct = (updatedProduct) => {
    updateProjectPart(
      'products',
      products.map((p) => (p.id === updatedProduct.id ? updatedProduct : p))
    )
  }

  const addProduct = () => {
    updateProjectPart('products', [
      ...products,
      {
        id: shortid(),
        name: '',
        category: '',
      },
    ])
  }

  const removeProduct = (id) => {
    updateProjectPart(
      'products',
      products.filter((p) => p.id !== id)
    )
  }

  const getLinkedScreens = (productId) =>
    Object.values(project.screens || {}).filter((s) => s.meta.product === productId) || []

  const getProduct = useCallback((id) => products.find((p) => p.id === id), [products])

  return {
    products,
    addProduct,
    getLinkedScreens,
    getProduct,
    saveProduct,
    removeProduct,
    updateProducts,
    canEdit,
  }
}
